import axiosLogin from "global/helpers/axiosLogin";
import { parseBackendError } from "global/utils/errorHandler";
import {
  MEDICO_POR_MATRICULA,
  MEDICO_POR_MATRICULA_FAIL,
  MEDICO_POR_MATRICULA_SUCCESS,
  SELECCIONA_MEDICO_LABO,
  SELECCIONA_MEDICO_LABO_FAIL,
  SELECCIONA_MEDICO_LABO_SUCCESS,
  SELECCIONA_MEDICO_TURNO,
  SELECCIONA_MEDICO_TURNO_FAIL,
  SELECCIONA_MEDICO_TURNO_SUCCESS,
} from "../ActionTypes";

export const wsGetMedicoPorMatricula = (matricula, nextStep) => (dispatch) => {
  dispatch({ type: MEDICO_POR_MATRICULA });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/medico-solicitante/por-matricula/${matricula}`)
      .then((resp) => {
        dispatch({ type: MEDICO_POR_MATRICULA_SUCCESS, payload: resp.data });
        if (nextStep) {
          nextStep(true);
        }
      })
      .catch((err) => {
        const parsedError = parseBackendError(err);
        dispatch({ type: MEDICO_POR_MATRICULA_FAIL, payload: parsedError });
        if (nextStep) {
          nextStep(false, parsedError);
        }
      });
  });
};

export const wsPutSeleccionarMedicoLabo =
  (idProtocolo, medSolicitante, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_LABO });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          `/his/medico-solicitante/laboratorio/matricula/${idProtocolo}/${medSolicitante}/${
            !idPacFamiliar ? -1 : idPacFamiliar
          }`
        )
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_LABO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };

export const wsPutSeleccionaMedicoTurno =
  (idTurno, medSolicitante, idPacFamiliar, nextStep) => (dispatch) => {
    dispatch({ type: SELECCIONA_MEDICO_TURNO });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(
          `/his/medico-solicitante/turno/matricula/${idTurno}/${medSolicitante}/${
            !idPacFamiliar ? -1 : idPacFamiliar
          }`
        )
        .then((resp) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_SUCCESS });
          if (nextStep) {
            nextStep(true);
          }
        })
        .catch((err) => {
          dispatch({ type: SELECCIONA_MEDICO_TURNO_FAIL });
          if (nextStep) {
            nextStep(false);
          }
        });
    });
  };
